import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '什么是"亚洲人成长之路"？',
    answer: '亚洲人成长之路是一个专注于亚洲人群全面发展的知识平台，我们汇聚来自各行各业的资深作者和思想领袖，围绕职业发展、个人成长、文化认同、领导力等核心议题，提供系统性的深度内容。我们的使命是帮助每一位亚洲人在全球化时代找到属于自己的成长路径。',
  },
  {
    question: '这个平台适合哪些人群？',
    answer: '我们的内容面向所有关注自我成长的亚洲人群，包括：在职场中寻求突破的专业人士、探索文化身份认同的移民二代、有志于领导力发展的管理者、正在经历职业转型的职场人、以及所有对个人成长和文化议题感兴趣的读者。无论您身处亚洲还是海外，都能在这里找到有价值的内容。',
  },
  {
    question: '如何开始我的成长之路？',
    answer: '我们建议您从"核心议题"板块开始，选择最符合您当前需求的领域（如职业发展、个人成长、文化认同等），浏览该领域的精选文章。我们也推荐订阅我们的每周资讯，获取最新内容和成长资源。成长是一个持续的过程，关键是保持学习的心态和行动的习惯。',
  },
  {
    question: '平台的内容是如何产生的？',
    answer: '我们的内容由来自不同领域的资深作者创作，包括企业高管、学术研究者、职业规划师、心理咨询师和文化评论者。每篇文章都经过编辑团队的严格审核，确保内容的深度、准确性和实用性。',
  },
  {
    question: '我能为平台贡献内容吗？',
    answer: '我们欢迎志同道合的作者加入！如果您在亚洲人成长的某个领域有独特的见解和实践经验，欢迎通过"关于我们"页面的联系方式与我们取得联系。我们期待听到您的声音。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <section className="py-14 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-600">
              关于亚洲人成长之路，您可能想了解的问题。
            </p>
          </div>

          <div className="space-y-3">
            {faqData.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 pr-4">
                    {faq.question}
                  </h3>
                  <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  </div>
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}